angular.module('MimosaApp').directive('pageBlock', ['$compile', '$window', function($compile, $window) {
    return {
        templateUrl: "app/partials/page-block.html",
        scope: {
            title: "@",
            body: "@"
        }
    }
}]);